import { useEffect, useState } from 'react';
import { PromiseState } from 'react-refetch';

import getValidChartDotsNumber from 'components/data-visualization/DoubleChart/utils/getValidChartDotsNumber';

const usePlaylistData = (data: PromiseState<any>): any => {
  const [playlistData, setPlaylistData] = useState<any>();
  const [entityId, setEntityId] = useState('');

  useEffect(() => {
    if (data.fulfilled && !data.value) return;

    if (data?.value?.length > 0) {
      setEntityId(data.value[0].entity.id);
      const positionData =
        data.value[0].playlists.length > 0 &&
        getValidChartDotsNumber(data.value[0].playlists[0].positionData);
      const notNullPositionValues =
        positionData.length > 0 &&
        positionData.filter(
          (item: any) => item.position !== 0 && item.position !== null
        ).length > 0;
      const playlist = notNullPositionValues
        ? positionData.filter((item: any) => item.position !== 0)
        : null;
      setPlaylistData(playlist);
    }
  }, [data]);

  return {
    playlistData,
    entityId,
  };
};

export default usePlaylistData;
